import {AfterViewInit, Component, ElementRef, Inject, OnInit, ViewChild} from '@angular/core';
import {ActivatedRoute} from '@angular/router';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {TranslateService} from '@ngx-translate/core';
import {ToastrService} from 'ngx-toastr';
import {ProjectService} from '../../services/project/project.service';
import {ProjectMeasureService} from '../../services/project-measure/project-measure.service';
import {ProjectMeasureGraphicStateService} from '../../services/project-measure-graphic-state/project-measure-graphic-state.service';
import {LocalStorageViewsService} from '../../services/local-storage-views/local-storage-views.service';
import {Location} from '../../types/location.type';
import {Project} from '../../classes/project/project';
import {LocationDataProcessMeasure} from '../../classes/offset/LocationDataProcessMeasure';

@Component({
  selector: 'app-project-measure-offset',
  templateUrl: './data-processing-measure.component.html',
  styleUrls: ['./data-processing-measure.component.css']
})
export class DataProcessingMeasureComponent implements OnInit {

  disabled = false;
  index: number = 0;

  @ViewChild('tabGroup') tabGroup;
  @ViewChild('file') fileInput: ElementRef;

  parentPanelExpanded = true;

  project: Project;
  locations: Location.serverSide[];
  thresholdTable: LocationDataProcessMeasure[] = [];

  selectedParentLocation: Location.serverSide;
  selectedChildLocation: Location.serverSide;
  private _showSpinner = false;

  set showSpinner(value: boolean) {
    setTimeout(() => {
      this._showSpinner = value;
    });
  }

  get showSpinner() {
    return this._showSpinner;
  }

  comment = '';
  invertedDirection = false;

  private idProject: number;

  private get selectedLocation() {
    const location = !!this.selectedChildLocation ? this.selectedChildLocation : this.selectedParentLocation;
    return location ? location : {};
  }

  constructor(private route: ActivatedRoute,
              private matDialogRef: MatDialogRef<DataProcessingMeasureComponent>,
              private projectMeasureService: ProjectMeasureService,
              private projectService: ProjectService,
              private translateService: TranslateService,
              private toastr: ToastrService,
              private graphState: ProjectMeasureGraphicStateService,
              private localStorageService: LocalStorageViewsService,
              @Inject(MAT_DIALOG_DATA) private data: IDataProcessingMeasureParameters
  ) {
  }

  ngOnInit() {
    this.idProject = this.data.idProject;
    this.index = this.data.indexModal;

    if (this.data.thresholdTable) {
      this.thresholdTable = this.data.thresholdTable;
    } else {
      const graphCompView = this.localStorageService.getGraphicalComponentView(this.idProject, this.localStorageService.getCurrentIndex(this.idProject));
      this.thresholdTable = graphCompView.thresholdTable;
    }
    const locationId = this.data ? this.data.locationId : null;
    const locations = this.graphState.get('locationsFromServer').filter((location) => location.active
    );
    this.handleLocations(locations, locationId);
  }


  selectLocation(location, source: 'parent' | 'child') {
    if (source === 'parent') {
      this.selectedParentLocation = location;
      this.selectedParentLocation.children = this.selectedParentLocation.children.filter((l) => l.active);
      this.selectedChildLocation = null;
    } else {
      this.selectedChildLocation = location;
    }
  }

  private handleLocations(locations: Location.serverSide[], selectedLocationId = null) {
    this.locations = locations.filter(
      (location) => !location.parent
    );
    if (selectedLocationId) {
      this.selectLocationFromId(selectedLocationId, locations);
    }
  }

  private selectLocationFromId(locationId: number, allLocations: any[]) {
    // todo: put in a service ?
    const location = allLocations.find((l) => locationId === l.id);
    if (location) {
      if (location.parent) {
        const parentLocationId = location.parent.id;
        this.selectedParentLocation = allLocations.find((l) => parentLocationId === l.id);
        this.selectedChildLocation = location;
      } else {
        this.selectedParentLocation = location;
      }
    }

  }

}

export interface IDataProcessingMeasureParameters {
  idProject: number;
  date?: number; // offset Date
  dateStart: Date;
  dateEnd: Date;
  indexModal: DataProcessingMeasureTypes;
  offset?: any;
  locationId?: number;
  thresholdTable?: any;
}

export enum DataProcessingMeasureTypes {
  offset,
  erase,
  threshold
}
